import { Box, PageLoader } from '@customerio/pluma-components/react';

export function LoadingPage() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      flexGrow="1"
      h="full"
      style={{ minHeight: '200px' }}
    >
      <PageLoader />
    </Box>
  );
}
